import { UserType } from '../models/pages/login.d';
import { Log } from 'ng2-logger';
import { number } from 'prop-types';
import { EnumHelpers } from './enumHelper';

const _logger = Log.create('SecurityContext.ts');

export enum SecurityContextType {
    None = 0,
    System = 1,
    Organization = 2,
    Program = 4,
    Course = 8,
    Class = 16,
    Group = 32,
    User = 64,
    Activity = 128,
    ActivityIncomplete = 129,
    MasterCourse = 256,
    Term = 512
}

export enum SecurityPermissionType {
    None = 0,
    Core_ManageGlobalization = 1,
    Core_ManageHelp = 2,
    Core_ManageHelpers = 3,
    Core_ViewHelp = 4,
    Core_ManageMyFiles = 5,
    Core_ViewMyFiles = 6,
    Core_ManageSharedFiles = 7,
    Core_ViewSharedFiles = 8,
    Core_Report = 9,
    Core_ClearCache = 10,
    Core_CockpitView = 11,
    Core_ShowNotification = 11,
    Security_Login = 50,
    Security_ManagePasswordPolicy = 51,
    Security_ListRoles = 52,
    Security_ManageRoles = 53,
    Security_SimulateUser = 54,
    Activity_Add = 100,
    Activity_Delete = 101,
    Activity_Edit = 102,
    Activity_Report = 103,
    Activity_View = 104,
    Activity_ViewMyActivities = 105,
    Activity_ViewMyCourses = 106,
    Activity_ViewMyTasks = 107,
    Activity_Assignment_DownloadAssignmentDocument = 108,
    Activity_Assignment_DownloadAssignmentResponses = 109,
    Activity_Assignment_Evaluate = 110,
    Activity_Assignment_UploadAssignmentResponse = 111,
    Activity_Course_Add = 112,
    Activity_Course_Archive = 113,
    Activity_Course_Delete = 114,
    Activity_Course_Edit = 115,
    Activity_Course_List = 116,
    Activity_Course_ManageGroups = 117,
    Activity_Elesson_InstallNewScorm = 118,
    Activity_Elesson_ManageScoData = 119,
    Activity_Exam_ChangeCorrectAnswer = 120,
    Activity_Exam_ExamSupport = 121,
    Activity_Exam_GiveAttemptRight = 122,
    Activity_Exam_LiveExamDashboard = 123,
    Activity_Exam_ReCalculate = 124,
    Activity_Exam_Report = 125,
    Activity_Exam_ViewExamQuestions = 126,
    Activity_Survey_Moderate = 127,
    Activity_Survey_Report = 128,
    Activity_Survey_View = 129,
    Activity_GradeBook_Manage = 130,
    Activity_GradeBook_View = 131,
    Activity_Exam_StudentReport = 132,
    Activity_Complete = 133,
    Class_Add = 200,
    Class_Archive = 201,
    Class_Delete = 202,
    Class_Edit = 203,
    Class_List = 204,
    Class_Manage = 205,
    User_Add = 250,
    User_AddMass = 251,
    User_Delete = 252,
    User_Edit = 253,
    User_List = 254,
    User_SeeClassmates = 255,
    User_SeeClassmatesContactInfo = 256,
    User_SelfChangeEmail = 257,
    User_SelfChangeId = 258,
    User_SelfChangePassword = 259,
    User_SelfChangePicture = 260,
    User_SelfViewProfile = 261,
    User_ViewProfile = 262,
    Organization_Edit = 300,
    Organization_EditProgram = 301,
    Organization_ManageOrganizationalUnit = 302,
    Organization_ManageProgram = 303,
    Organization_ManageTerm = 304,
    MasterCourse_Add = 350,
    MasterCourse_Delete = 351,
    MasterCourse_Edit = 352,
    MasterCourse_View = 353,
    Message_View = 400,
    Message_MessageInspection = 401,
    Message_ReplyToConversation = 402,
    Message_Report = 403,
    Message_SendMassMessage = 404,
    Message_StartConversation = 405,
    QuestionBank_AddMass = 450,
    QuestionBank_Copy = 451,
    QuestionBank_Add = 452,
    QuestionBank_Edit = 453,
    QuestionBank_Delete = 454,
    QuestionBank_EditUsedQuestion = 455,
    QuestionBank_Statistics = 456,
    QuestionBank_View = 457,
    HelpDesk_CloseTicket = 500,
    HelpDesk_Create = 501,
    HelpDesk_Delete = 502,
    HelpDesk_Forward = 503,
    HelpDesk_ManageCategories = 504,
    HelpDesk_Reply = 505,
    HelpDesk_Manage = 506,
    Forum_CreateThread = 550,
    Forum_ModerateThread = 551,
    Forum_Report = 552,
    Forum_ViewThread = 553,
    Announcement_Add = 600,
    Announcement_Delete = 601,
    Announcement_Report = 602,
    Announcement_SendEmail = 603,
    Announcement_SendSMS = 604,
    Announcement_View = 605,
    FAQ_Manage = 650,
    FAQ_View = 651,
    DigitalLibrary_Manage = 700,
    DigitalLibrary_View = 701,
    Group_Add = 750,
    Group_Delete = 751,
    Group_Edit = 752,
    Group_List = 753,
    Feed_View = 800,
    Teacher_References=801,
    Student_References=802,

    Builtin_Admin = -1,

    Builtin_Teacher = -2,
    Builtin_Student = -3,
    Builtin_ProgramUser = -4,
    Builtin_ProgramAdmin = -5,
    Builtin_Parent = -6
}

export interface IContextMapping {
    permissionType: SecurityPermissionType;
    context: string;
}

export interface ISecurityPermissionMapList {
    securityContextType: SecurityContextType;
    permissionType: SecurityPermissionType;
    userType: UserType;
}

let _instance: PermissionGenerator;
export default class PermissionGenerator {

    public static create(): PermissionGenerator {
        return new PermissionGenerator();
    }

    public ContextMap: IContextMapping[] = [];
    public RoleMap: IContextMapping[] = [];
    public PermissionMapList: ISecurityPermissionMapList[] = [];
    public BuiltInRolePermissionMappings: string[] = [];

    constructor() {

        if (_instance) {
            return _instance;
        } else {
            this.init();
            _instance = this;
        }
    }
    private init() {
        this.getContextMap();
        this.getRoleMap();
        this.getBuiltInRolePermissionMapping();
        this.getPermissionMapList();
    }

    private getContextMap() {
        this.ContextMap = this.generateContexMapping();
    }

    private getRoleMap() {

        this.RoleMap = this.generateRoleMapping();
    }

    private getBuiltInRolePermissionMapping() {

        this.RoleMap.forEach((value: IContextMapping) => {
            const types: string[] = value.context.split(',');

            types.forEach((typesValue: string) => {
                this.BuiltInRolePermissionMappings.push(value.permissionType.toString() + '_' + EnumHelpers.toKeyValueArray(UserType).filter(x => x.key === typesValue)[0].value);
            });
        });
    }

    private getPermissionMapList() {
        const permTypesAdmin: SecurityPermissionType[] = this.getDefaultPermission(UserType.Admin);
        const securityContextType: Array<{ key: string, value: number }> = EnumHelpers.toKeyValueArray(SecurityContextType);
        permTypesAdmin.forEach((permType: SecurityPermissionType) => {
            securityContextType.forEach((contextType: { key: string, value: number }) => {
                const contextTypeInsertParameter: SecurityContextType = contextType.value;
                this.PermissionMapList.push({ securityContextType: contextTypeInsertParameter, permissionType: permType, userType: UserType.Admin });
            });
        });

        const permTypesProgramAdmin = this.getDefaultPermission(UserType.ProgramAdmin);
        permTypesProgramAdmin.forEach((permType: SecurityPermissionType) => {
            securityContextType.forEach((contextType: { key: string, value: number }) => {
                const contextTypeInsertParameter: SecurityContextType = contextType.value;
                this.PermissionMapList.push({ securityContextType: contextTypeInsertParameter, permissionType: permType, userType: UserType.ProgramAdmin });
            });
        });

        const permTypesTeacher = this.getDefaultPermission(UserType.Teacher);
        permTypesTeacher.forEach((permType: SecurityPermissionType) => {
            securityContextType.forEach((contextType: { key: string, value: number }) => {
                const contextTypeInsertParameter: SecurityContextType = contextType.value;
                this.PermissionMapList.push({ securityContextType: contextTypeInsertParameter, permissionType: permType, userType: UserType.Teacher });
            });
        });

        const permTypesProgramUser = this.getDefaultPermission(UserType.ProgramUser);
        permTypesProgramUser.forEach((permType: SecurityPermissionType) => {
            securityContextType.forEach((contextType: { key: string, value: number }) => {
                const contextTypeInsertParameter: SecurityContextType = contextType.value;
                this.PermissionMapList.push({ securityContextType: contextTypeInsertParameter, permissionType: permType, userType: UserType.ProgramUser });
            });
        });

        const permTypesStudent = this.getDefaultPermission(UserType.Student);
        permTypesStudent.forEach((permType: SecurityPermissionType) => {
            securityContextType.forEach((contextType: { key: string, value: number }) => {
                const contextTypeInsertParameter: SecurityContextType = contextType.value;
                this.PermissionMapList.push({ securityContextType: contextTypeInsertParameter, permissionType: permType, userType: UserType.Student });
            });
        });
    }

    private getDefaultPermission(userType: UserType): SecurityPermissionType[] {
        const arrayList: SecurityPermissionType[] = [];
        const permissionTypeList: Array<{ key: string, value: number }> = EnumHelpers.toKeyValueArray(SecurityPermissionType);

        permissionTypeList.forEach((value: { key: string, value: number }) => {
            if (this.BuiltInRolePermissionMappings.includes(value.value + '_' + userType.toString())) {
                const permT: SecurityPermissionType = value.value;
                arrayList.push(permT);
            }
        });
        return arrayList;
    }

    private generateContexMapping(): IContextMapping[] {
        const contextMap: IContextMapping[] = [];
        contextMap.push({ permissionType: SecurityPermissionType.Core_ManageGlobalization, context: 'Organization' });
        contextMap.push({ permissionType: SecurityPermissionType.Core_ManageHelp, context: 'Organization' });
        contextMap.push({ permissionType: SecurityPermissionType.Core_ManageHelpers, context: 'Organization' });
        contextMap.push({ permissionType: SecurityPermissionType.Core_ViewHelp, context: 'Organization' });
        contextMap.push({ permissionType: SecurityPermissionType.Security_Login, context: 'System' });
        contextMap.push({ permissionType: SecurityPermissionType.Security_ManagePasswordPolicy, context: 'Organization' });
        contextMap.push({ permissionType: SecurityPermissionType.Security_ListRoles, context: 'Organization,Program' });
        contextMap.push({ permissionType: SecurityPermissionType.Security_ManageRoles, context: 'Organization' });
        contextMap.push({ permissionType: SecurityPermissionType.Security_SimulateUser, context: 'Organization,Program' });
        contextMap.push({ permissionType: SecurityPermissionType.Activity_Add, context: 'Program,Course,Class' });
        contextMap.push({ permissionType: SecurityPermissionType.Activity_Delete, context: 'Program,Course,Class' });
        contextMap.push({ permissionType: SecurityPermissionType.Activity_Edit, context: 'Program,Course,Class' });
        contextMap.push({ permissionType: SecurityPermissionType.Activity_Report, context: 'Organization,Program,Course,Class' });
        contextMap.push({ permissionType: SecurityPermissionType.Activity_View, context: 'Program,Course,Class' });
        contextMap.push({ permissionType: SecurityPermissionType.Activity_ViewMyActivities, context: 'System' });
        contextMap.push({ permissionType: SecurityPermissionType.Activity_ViewMyCourses, context: 'System' });
        contextMap.push({ permissionType: SecurityPermissionType.Activity_ViewMyTasks, context: 'System' });
        contextMap.push({ permissionType: SecurityPermissionType.Activity_Assignment_DownloadAssignmentDocument, context: 'Program,Course,Class' });
        contextMap.push({ permissionType: SecurityPermissionType.Activity_Assignment_DownloadAssignmentResponses, context: 'Program,Course,Class' });
        contextMap.push({ permissionType: SecurityPermissionType.Activity_Assignment_Evaluate, context: 'Program,Course,Class' });
        contextMap.push({ permissionType: SecurityPermissionType.Activity_Assignment_UploadAssignmentResponse, context: 'Class' });
        contextMap.push({ permissionType: SecurityPermissionType.Activity_Course_Add, context: 'Program' });
        contextMap.push({ permissionType: SecurityPermissionType.Activity_Course_Archive, context: 'Program' });
        contextMap.push({ permissionType: SecurityPermissionType.Activity_Course_Delete, context: 'Program' });
        contextMap.push({ permissionType: SecurityPermissionType.Activity_Course_Edit, context: 'Program' });
        contextMap.push({ permissionType: SecurityPermissionType.Activity_Course_List, context: 'Program' });
        contextMap.push({ permissionType: SecurityPermissionType.Activity_Course_ManageGroups, context: 'Program,Course' });
        contextMap.push({ permissionType: SecurityPermissionType.Activity_Elesson_InstallNewScorm, context: 'Program,Course,Class' });
        contextMap.push({ permissionType: SecurityPermissionType.Activity_Elesson_ManageScoData, context: 'Program,Course,Class' });
        contextMap.push({ permissionType: SecurityPermissionType.Activity_Exam_ChangeCorrectAnswer, context: 'Program,Course,Class' });
        contextMap.push({ permissionType: SecurityPermissionType.Activity_Exam_ExamSupport, context: 'Program,Course,Class' });
        contextMap.push({ permissionType: SecurityPermissionType.Activity_Exam_GiveAttemptRight, context: 'Program,Course,Class' });
        contextMap.push({ permissionType: SecurityPermissionType.Activity_Exam_LiveExamDashboard, context: 'Program,Course,Class' });
        contextMap.push({ permissionType: SecurityPermissionType.Activity_Exam_ReCalculate, context: 'Program,Course,Class' });
        contextMap.push({ permissionType: SecurityPermissionType.Activity_Exam_Report, context: 'Program,Course,Class' });
        contextMap.push({ permissionType: SecurityPermissionType.Activity_Exam_StudentReport, context: 'Program,Course,Class' });
        contextMap.push({ permissionType: SecurityPermissionType.Activity_Exam_ViewExamQuestions, context: 'Program,Course,Class' });
        contextMap.push({ permissionType: SecurityPermissionType.Activity_Survey_Moderate, context: 'Program,Course,Class' });
        contextMap.push({ permissionType: SecurityPermissionType.Activity_Survey_Report, context: 'Program,Course,Class' });
        contextMap.push({ permissionType: SecurityPermissionType.Activity_Survey_View, context: 'Program,Course,Class' });
        contextMap.push({ permissionType: SecurityPermissionType.Activity_GradeBook_Manage, context: 'Program,Course,Class' });
        contextMap.push({ permissionType: SecurityPermissionType.Activity_GradeBook_View, context: 'Program,Course,Class' });
        contextMap.push({ permissionType: SecurityPermissionType.Activity_Complete, context: 'Program,Course,Class' });
        contextMap.push({ permissionType: SecurityPermissionType.Class_Add, context: 'Organization,Program,Course,Class' });
        contextMap.push({ permissionType: SecurityPermissionType.Class_Archive, context: 'Organization,Program,Course' });
        contextMap.push({ permissionType: SecurityPermissionType.Class_Delete, context: 'Organization,Program,Course,Class' });
        contextMap.push({ permissionType: SecurityPermissionType.Class_Edit, context: 'Organization,Program,Course,Class' });
        contextMap.push({ permissionType: SecurityPermissionType.Class_List, context: 'Organization,Program,Course' });
        contextMap.push({ permissionType: SecurityPermissionType.Class_Manage, context: 'Organization,Program,Course' });
        contextMap.push({ permissionType: SecurityPermissionType.User_Add, context: 'Organization,Program' });
        contextMap.push({ permissionType: SecurityPermissionType.User_AddMass, context: 'Organization,Program' });
        contextMap.push({ permissionType: SecurityPermissionType.User_Delete, context: 'Organization,Program' });
        contextMap.push({ permissionType: SecurityPermissionType.User_Edit, context: 'Organization,Program' });
        contextMap.push({ permissionType: SecurityPermissionType.User_List, context: 'Organization,Program,Course' });
        contextMap.push({ permissionType: SecurityPermissionType.User_SeeClassmates, context: 'Course,Class' });
        contextMap.push({ permissionType: SecurityPermissionType.User_SeeClassmatesContactInfo, context: 'Course,Class' });
        contextMap.push({ permissionType: SecurityPermissionType.User_SelfChangeEmail, context: 'System' });
        contextMap.push({ permissionType: SecurityPermissionType.User_SelfChangeId, context: 'System' });
        contextMap.push({ permissionType: SecurityPermissionType.User_SelfChangePassword, context: 'System' });
        contextMap.push({ permissionType: SecurityPermissionType.User_SelfChangePicture, context: 'System' });
        contextMap.push({ permissionType: SecurityPermissionType.User_SelfViewProfile, context: 'System' });
        contextMap.push({ permissionType: SecurityPermissionType.User_ViewProfile, context: 'Organization,Program,Course,Class' });
        contextMap.push({ permissionType: SecurityPermissionType.Organization_Edit, context: 'Organization' });
        contextMap.push({ permissionType: SecurityPermissionType.Organization_EditProgram, context: 'Organization,Program' });
        contextMap.push({ permissionType: SecurityPermissionType.Organization_ManageOrganizationalUnit, context: 'Organization' });
        contextMap.push({ permissionType: SecurityPermissionType.Organization_ManageProgram, context: 'Organization' });
        contextMap.push({ permissionType: SecurityPermissionType.Organization_ManageTerm, context: 'Organization' });
        contextMap.push({ permissionType: SecurityPermissionType.MasterCourse_Add, context: 'Organization,Program' });
        contextMap.push({ permissionType: SecurityPermissionType.MasterCourse_Delete, context: 'Organization,Program' });
        contextMap.push({ permissionType: SecurityPermissionType.MasterCourse_Edit, context: 'Organization,Program' });
        contextMap.push({ permissionType: SecurityPermissionType.MasterCourse_View, context: 'Organization,Program' });
        contextMap.push({ permissionType: SecurityPermissionType.Message_View, context: 'System' });
        contextMap.push({ permissionType: SecurityPermissionType.Message_MessageInspection, context: 'Organization,Program' });
        contextMap.push({ permissionType: SecurityPermissionType.Message_ReplyToConversation, context: 'System' });
        contextMap.push({ permissionType: SecurityPermissionType.Message_Report, context: 'Organization,Program,Course,Class' });
        contextMap.push({ permissionType: SecurityPermissionType.Message_SendMassMessage, context: 'Organization,Program,Course,Class' });
        contextMap.push({ permissionType: SecurityPermissionType.Message_StartConversation, context: 'System' });
        contextMap.push({ permissionType: SecurityPermissionType.QuestionBank_AddMass, context: 'Organization,Program,Course' });
        contextMap.push({ permissionType: SecurityPermissionType.QuestionBank_Copy, context: 'Organization,Program,Course' });
        contextMap.push({ permissionType: SecurityPermissionType.QuestionBank_Add, context: 'Organization,Program,Course' });
        contextMap.push({ permissionType: SecurityPermissionType.QuestionBank_Edit, context: 'Organization,Program,Course' });
        contextMap.push({ permissionType: SecurityPermissionType.QuestionBank_Delete, context: 'Organization,Program,Course' });
        contextMap.push({ permissionType: SecurityPermissionType.QuestionBank_EditUsedQuestion, context: 'Organization,Program,Course' });
        contextMap.push({ permissionType: SecurityPermissionType.QuestionBank_Statistics, context: 'Organization,Program,Course' });
        contextMap.push({ permissionType: SecurityPermissionType.QuestionBank_View, context: 'Organization,Program,Course' });
        contextMap.push({ permissionType: SecurityPermissionType.HelpDesk_CloseTicket, context: 'Organization,Program' });
        contextMap.push({ permissionType: SecurityPermissionType.HelpDesk_Create, context: 'Organization,Program' });
        contextMap.push({ permissionType: SecurityPermissionType.HelpDesk_Delete, context: 'Organization,Program' });
        contextMap.push({ permissionType: SecurityPermissionType.HelpDesk_Forward, context: 'Organization,Program' });
        contextMap.push({ permissionType: SecurityPermissionType.HelpDesk_ManageCategories, context: 'Organization,Program' });
        contextMap.push({ permissionType: SecurityPermissionType.HelpDesk_Reply, context: 'Organization,Program' });
        contextMap.push({ permissionType: SecurityPermissionType.HelpDesk_Manage, context: 'Organization,Program' });
        contextMap.push({ permissionType: SecurityPermissionType.Forum_CreateThread, context: 'Organization,Program,Course,Class' });
        contextMap.push({ permissionType: SecurityPermissionType.Forum_ModerateThread, context: 'Organization,Program,Course,Class' });
        contextMap.push({ permissionType: SecurityPermissionType.Forum_Report, context: 'Organization,Program,Course,Class' });
        contextMap.push({ permissionType: SecurityPermissionType.Forum_ViewThread, context: 'Organization,Program,Course,Class' });
        contextMap.push({ permissionType: SecurityPermissionType.Announcement_Add, context: 'Organization,Program,Course,Class' });
        contextMap.push({ permissionType: SecurityPermissionType.Announcement_Delete, context: 'Organization,Program,Course,Class' });
        contextMap.push({ permissionType: SecurityPermissionType.Announcement_Report, context: 'Organization,Program,Course,Class' });
        contextMap.push({ permissionType: SecurityPermissionType.Announcement_SendEmail, context: 'Organization,Program,Course,Class' });
        contextMap.push({ permissionType: SecurityPermissionType.Announcement_SendSMS, context: 'Organization,Program,Course,Class' });
        contextMap.push({ permissionType: SecurityPermissionType.Announcement_View, context: 'Organization,Program,Course,Class' });
        contextMap.push({ permissionType: SecurityPermissionType.FAQ_Manage, context: 'Organization,Program' });
        contextMap.push({ permissionType: SecurityPermissionType.FAQ_View, context: 'Organization,Program,Course,Class' });
        contextMap.push({ permissionType: SecurityPermissionType.Feed_View, context: 'Organization,Program,Course,Class' });
        contextMap.push({ permissionType: SecurityPermissionType.DigitalLibrary_Manage, context: 'Organization,Program,Course' });
        contextMap.push({ permissionType: SecurityPermissionType.DigitalLibrary_View, context: 'Organization,Program,Course,Class' });
        contextMap.push({ permissionType: SecurityPermissionType.Core_ManageSharedFiles, context: 'Organization,Program' });
        contextMap.push({ permissionType: SecurityPermissionType.Core_ViewSharedFiles, context: 'Organization,Program,Course,Class' });
        contextMap.push({ permissionType: SecurityPermissionType.Core_ManageMyFiles, context: 'System' });
        contextMap.push({ permissionType: SecurityPermissionType.Core_ViewMyFiles, context: 'System' });
        contextMap.push({ permissionType: SecurityPermissionType.Core_Report, context: 'Organization,Program,Course,Class' });
        contextMap.push({ permissionType: SecurityPermissionType.Group_Add, context: 'Organization,Program' });
        contextMap.push({ permissionType: SecurityPermissionType.Group_Delete, context: 'Organization,Program' });
        contextMap.push({ permissionType: SecurityPermissionType.Group_Edit, context: 'Organization,Program' });
        contextMap.push({ permissionType: SecurityPermissionType.Group_List, context: 'Organization,Program' });
        contextMap.push({ permissionType: SecurityPermissionType.Core_ClearCache, context: 'Organization' });
        contextMap.push({ permissionType: SecurityPermissionType.Core_ShowNotification, context: 'Organization,Program' });
        contextMap.push({ permissionType: SecurityPermissionType.Core_CockpitView, context: 'Organization' });
        contextMap.push({ permissionType: SecurityPermissionType.Builtin_ProgramAdmin, context: 'Program' });
        contextMap.push({ permissionType: SecurityPermissionType.Builtin_Admin, context: 'Organization' });
        contextMap.push({ permissionType: SecurityPermissionType.Teacher_References, context: 'Organization' });
        contextMap.push({ permissionType: SecurityPermissionType.Student_References, context: 'Organization' });

        return contextMap;
    }

    private generateRoleMapping(): IContextMapping[] {
        const contextMap: IContextMapping[] = [];
        contextMap.push({ permissionType: SecurityPermissionType.Activity_Add, context: 'Admin,ProgramAdmin,Teacher' });
        contextMap.push({ permissionType: SecurityPermissionType.Activity_Assignment_DownloadAssignmentDocument, context: 'Admin,ProgramAdmin,Teacher,Student' });
        contextMap.push({ permissionType: SecurityPermissionType.Activity_Assignment_DownloadAssignmentResponses, context: 'Admin,ProgramAdmin,Teacher' });
        contextMap.push({ permissionType: SecurityPermissionType.Activity_Assignment_Evaluate, context: 'Admin,ProgramAdmin,Teacher' });
        contextMap.push({ permissionType: SecurityPermissionType.Activity_Assignment_UploadAssignmentResponse, context: 'Student' });
        contextMap.push({ permissionType: SecurityPermissionType.Activity_Course_Add, context: 'Admin,ProgramAdmin' });
        contextMap.push({ permissionType: SecurityPermissionType.Activity_Course_Archive, context: 'Admin,ProgramAdmin' });
        contextMap.push({ permissionType: SecurityPermissionType.Activity_Course_Delete, context: 'Admin,ProgramAdmin' });
        contextMap.push({ permissionType: SecurityPermissionType.Activity_Course_Edit, context: 'Admin,ProgramAdmin' });
        contextMap.push({ permissionType: SecurityPermissionType.Activity_Course_List, context: 'Admin,ProgramAdmin,Teacher' });
        contextMap.push({ permissionType: SecurityPermissionType.Activity_Course_ManageGroups, context: 'Admin,ProgramAdmin' });
        contextMap.push({ permissionType: SecurityPermissionType.Activity_Delete, context: 'Admin,ProgramAdmin,Teacher' });
        contextMap.push({ permissionType: SecurityPermissionType.Activity_Edit, context: 'Admin,ProgramAdmin,Teacher' });
        contextMap.push({ permissionType: SecurityPermissionType.Activity_Elesson_InstallNewScorm, context: 'Admin,ProgramAdmin,Teacher' });
        contextMap.push({ permissionType: SecurityPermissionType.Activity_Elesson_ManageScoData, context: 'Admin,ProgramAdmin,Teacher' });
        contextMap.push({ permissionType: SecurityPermissionType.Activity_Exam_ChangeCorrectAnswer, context: 'Admin,ProgramAdmin,Teacher' });
        contextMap.push({ permissionType: SecurityPermissionType.Activity_Exam_ExamSupport, context: 'Admin,ProgramAdmin,Teacher' });
        contextMap.push({ permissionType: SecurityPermissionType.Activity_Exam_GiveAttemptRight, context: 'Admin,ProgramAdmin,Teacher' });
        contextMap.push({ permissionType: SecurityPermissionType.Activity_Exam_LiveExamDashboard, context: 'Admin,ProgramAdmin,Teacher' });
        contextMap.push({ permissionType: SecurityPermissionType.Activity_Exam_ReCalculate, context: 'Admin,ProgramAdmin,Teacher' });
        contextMap.push({ permissionType: SecurityPermissionType.Activity_Exam_Report, context: 'Admin,ProgramAdmin,Teacher' });
        contextMap.push({ permissionType: SecurityPermissionType.Activity_Exam_StudentReport, context: 'Admin,ProgramAdmin,Teacher,Student,Parent' });
        contextMap.push({ permissionType: SecurityPermissionType.Activity_Exam_ViewExamQuestions, context: 'Admin,ProgramAdmin,Teacher' });
        contextMap.push({ permissionType: SecurityPermissionType.Activity_GradeBook_Manage, context: 'Admin,ProgramAdmin,Teacher' });
        contextMap.push({ permissionType: SecurityPermissionType.Activity_GradeBook_View, context: 'Student,Parent' });
        contextMap.push({ permissionType: SecurityPermissionType.Activity_Report, context: 'Admin,ProgramAdmin,Teacher' });
        contextMap.push({ permissionType: SecurityPermissionType.Activity_Survey_Moderate, context: 'Admin,ProgramAdmin,Teacher' });
        contextMap.push({ permissionType: SecurityPermissionType.Activity_Survey_Report, context: 'Admin,ProgramAdmin,Teacher' });
        contextMap.push({ permissionType: SecurityPermissionType.Activity_Survey_View, context: 'Admin,ProgramAdmin,Teacher,User' });
        contextMap.push({ permissionType: SecurityPermissionType.Activity_View, context: 'Admin,ProgramAdmin,Teacher,Student,Parent' });
        contextMap.push({ permissionType: SecurityPermissionType.Activity_ViewMyActivities, context: 'User' });
        contextMap.push({ permissionType: SecurityPermissionType.Activity_ViewMyCourses, context: 'User' });
        contextMap.push({ permissionType: SecurityPermissionType.Activity_ViewMyTasks, context: 'User' });
        contextMap.push({ permissionType: SecurityPermissionType.Activity_Complete, context: 'Student' });
        contextMap.push({ permissionType: SecurityPermissionType.Announcement_Add, context: 'Admin,ProgramAdmin,Teacher' });
        contextMap.push({ permissionType: SecurityPermissionType.Announcement_Delete, context: 'Admin,ProgramAdmin,Teacher' });
        contextMap.push({ permissionType: SecurityPermissionType.Announcement_Report, context: 'Admin,ProgramAdmin,Teacher' });
        contextMap.push({ permissionType: SecurityPermissionType.Announcement_SendEmail, context: 'Admin,ProgramAdmin,Teacher' });
        contextMap.push({ permissionType: SecurityPermissionType.Announcement_SendSMS, context: 'Admin,ProgramAdmin,Teacher' });
        contextMap.push({ permissionType: SecurityPermissionType.Announcement_View, context: 'User' });
        contextMap.push({ permissionType: SecurityPermissionType.Class_Add, context: 'Admin,ProgramAdmin,Teacher' });
        contextMap.push({ permissionType: SecurityPermissionType.Class_Archive, context: 'Admin,ProgramAdmin' });
        contextMap.push({ permissionType: SecurityPermissionType.Class_Delete, context: 'Admin,ProgramAdmin' });
        contextMap.push({ permissionType: SecurityPermissionType.Class_Edit, context: 'Admin,ProgramAdmin,Teacher' });
        contextMap.push({ permissionType: SecurityPermissionType.Class_List, context: 'Admin,ProgramAdmin,Teacher' });
        contextMap.push({ permissionType: SecurityPermissionType.Class_Manage, context: 'Admin,ProgramAdmin' });
        contextMap.push({ permissionType: SecurityPermissionType.Core_ManageGlobalization, context: 'Admin' });
        contextMap.push({ permissionType: SecurityPermissionType.Core_ManageHelp, context: 'Admin' });
        contextMap.push({ permissionType: SecurityPermissionType.Core_ManageHelpers, context: 'Admin' });
        contextMap.push({ permissionType: SecurityPermissionType.Core_ViewHelp, context: 'User,Admin' });
        contextMap.push({ permissionType: SecurityPermissionType.DigitalLibrary_Manage, context: 'Admin,ProgramAdmin,Teacher' });
        contextMap.push({ permissionType: SecurityPermissionType.DigitalLibrary_View, context: 'User' });
        contextMap.push({ permissionType: SecurityPermissionType.FAQ_Manage, context: 'Admin,ProgramAdmin' });
        contextMap.push({ permissionType: SecurityPermissionType.FAQ_View, context: 'User' });
        contextMap.push({ permissionType: SecurityPermissionType.Feed_View, context: 'User' });
        contextMap.push({ permissionType: SecurityPermissionType.Forum_CreateThread, context: 'Admin,ProgramAdmin,Teacher' });
        contextMap.push({ permissionType: SecurityPermissionType.Forum_ModerateThread, context: 'Admin,ProgramAdmin,Teacher' });
        contextMap.push({ permissionType: SecurityPermissionType.Forum_Report, context: 'Admin,ProgramAdmin,Teacher' });
        contextMap.push({ permissionType: SecurityPermissionType.Forum_ViewThread, context: 'User' });
        contextMap.push({ permissionType: SecurityPermissionType.HelpDesk_CloseTicket, context: 'Admin,ProgramAdmin' });
        contextMap.push({ permissionType: SecurityPermissionType.HelpDesk_Create, context: 'User' });
        contextMap.push({ permissionType: SecurityPermissionType.HelpDesk_Delete, context: 'Admin,ProgramAdmin' });
        contextMap.push({ permissionType: SecurityPermissionType.HelpDesk_Forward, context: 'Admin,ProgramAdmin' });
        contextMap.push({ permissionType: SecurityPermissionType.HelpDesk_ManageCategories, context: 'Admin,ProgramAdmin' });
        contextMap.push({ permissionType: SecurityPermissionType.HelpDesk_Reply, context: 'User' });
        contextMap.push({ permissionType: SecurityPermissionType.HelpDesk_Manage, context: 'Admin,ProgramAdmin' });
        contextMap.push({ permissionType: SecurityPermissionType.MasterCourse_Add, context: 'Admin,ProgramAdmin' });
        contextMap.push({ permissionType: SecurityPermissionType.MasterCourse_Delete, context: 'Admin,ProgramAdmin' });
        contextMap.push({ permissionType: SecurityPermissionType.MasterCourse_Edit, context: 'Admin,ProgramAdmin' });
        contextMap.push({ permissionType: SecurityPermissionType.MasterCourse_View, context: 'Admin,ProgramAdmin' });
        contextMap.push({ permissionType: SecurityPermissionType.Message_MessageInspection, context: 'Admin,ProgramAdmin' });
        contextMap.push({ permissionType: SecurityPermissionType.Message_ReplyToConversation, context: 'User' });
        contextMap.push({ permissionType: SecurityPermissionType.Message_Report, context: 'Admin,ProgramAdmin,Teacher' });
        contextMap.push({ permissionType: SecurityPermissionType.Message_SendMassMessage, context: 'Admin,ProgramAdmin,Teacher' });
        contextMap.push({ permissionType: SecurityPermissionType.Message_StartConversation, context: 'User' });
        contextMap.push({ permissionType: SecurityPermissionType.Message_View, context: 'User' });
        contextMap.push({ permissionType: SecurityPermissionType.Organization_Edit, context: 'Admin' });
        contextMap.push({ permissionType: SecurityPermissionType.Organization_EditProgram, context: 'Admin,ProgramAdmin' });
        contextMap.push({ permissionType: SecurityPermissionType.Organization_ManageOrganizationalUnit, context: 'Admin' });
        contextMap.push({ permissionType: SecurityPermissionType.Organization_ManageProgram, context: 'Admin' });
        contextMap.push({ permissionType: SecurityPermissionType.Organization_ManageTerm, context: 'Admin' });
        contextMap.push({ permissionType: SecurityPermissionType.QuestionBank_Add, context: 'Admin,ProgramAdmin,Teacher' });
        contextMap.push({ permissionType: SecurityPermissionType.QuestionBank_AddMass, context: 'Admin,ProgramAdmin,Teacher' });
        contextMap.push({ permissionType: SecurityPermissionType.QuestionBank_Copy, context: 'Admin,ProgramAdmin,Teacher' });
        contextMap.push({ permissionType: SecurityPermissionType.QuestionBank_Delete, context: 'Admin,ProgramAdmin,Teacher' });
        contextMap.push({ permissionType: SecurityPermissionType.QuestionBank_Edit, context: 'Admin,ProgramAdmin,Teacher' });
        contextMap.push({ permissionType: SecurityPermissionType.QuestionBank_EditUsedQuestion, context: 'Admin,ProgramAdmin,Teacher' });
        contextMap.push({ permissionType: SecurityPermissionType.QuestionBank_Statistics, context: 'Admin,ProgramAdmin,Teacher' });
        contextMap.push({ permissionType: SecurityPermissionType.QuestionBank_View, context: 'Admin,ProgramAdmin,Teacher' });
        contextMap.push({ permissionType: SecurityPermissionType.Security_ListRoles, context: 'Admin,ProgramAdmin' });
        contextMap.push({ permissionType: SecurityPermissionType.Security_Login, context: 'User' });
        contextMap.push({ permissionType: SecurityPermissionType.Security_ManagePasswordPolicy, context: 'Admin' });
        contextMap.push({ permissionType: SecurityPermissionType.Security_ManageRoles, context: 'Admin' });
        contextMap.push({ permissionType: SecurityPermissionType.Security_SimulateUser, context: 'Admin,ProgramAdmin' });
        contextMap.push({ permissionType: SecurityPermissionType.User_Add, context: 'Admin,ProgramAdmin' });
        contextMap.push({ permissionType: SecurityPermissionType.User_AddMass, context: 'Admin,ProgramAdmin' });
        contextMap.push({ permissionType: SecurityPermissionType.User_Delete, context: 'Admin,ProgramAdmin' });
        contextMap.push({ permissionType: SecurityPermissionType.User_Edit, context: 'Admin,ProgramAdmin' });
        contextMap.push({ permissionType: SecurityPermissionType.User_List, context: 'Admin,ProgramAdmin' });
        contextMap.push({ permissionType: SecurityPermissionType.User_SeeClassmates, context: 'Teacher,Student' });
        contextMap.push({ permissionType: SecurityPermissionType.User_SeeClassmatesContactInfo, context: 'Teacher,Student' });
        contextMap.push({ permissionType: SecurityPermissionType.User_SelfChangeEmail, context: 'User' });
        contextMap.push({ permissionType: SecurityPermissionType.User_SelfChangeId, context: 'User' });
        contextMap.push({ permissionType: SecurityPermissionType.User_SelfChangePassword, context: 'User' });
        contextMap.push({ permissionType: SecurityPermissionType.User_SelfChangePicture, context: 'User' });
        contextMap.push({ permissionType: SecurityPermissionType.User_SelfViewProfile, context: 'User' });
        contextMap.push({ permissionType: SecurityPermissionType.User_ViewProfile, context: 'Admin,ProgramAdmin,Teacher' });
        contextMap.push({ permissionType: SecurityPermissionType.Core_ManageMyFiles, context: 'Admin,ProgramAdmin,Teacher,Student,User' });
        contextMap.push({ permissionType: SecurityPermissionType.Core_ViewMyFiles, context: 'Admin,ProgramUser,ProgramAdmin,Teacher,Student' });
        contextMap.push({ permissionType: SecurityPermissionType.Core_ManageSharedFiles, context: 'Admin' });
        contextMap.push({ permissionType: SecurityPermissionType.Core_ViewSharedFiles, context: 'Admin,ProgramAdmin,Teacher' });
        contextMap.push({ permissionType: SecurityPermissionType.Core_Report, context: 'Admin,ProgramAdmin,Teacher,Student' });
        contextMap.push({ permissionType: SecurityPermissionType.Group_Add, context: 'Admin,ProgramAdmin' });
        contextMap.push({ permissionType: SecurityPermissionType.Group_Delete, context: 'Admin,ProgramAdmin' });
        contextMap.push({ permissionType: SecurityPermissionType.Group_Edit, context: 'Admin,ProgramAdmin' });
        contextMap.push({ permissionType: SecurityPermissionType.Group_List, context: 'Admin,ProgramAdmin' });
        contextMap.push({ permissionType: SecurityPermissionType.Core_ClearCache, context: 'Admin' });
        contextMap.push({ permissionType: SecurityPermissionType.Core_ShowNotification, context: 'Admin,ProgramAdmin' });
        contextMap.push({ permissionType: SecurityPermissionType.Core_CockpitView, context: 'Admin' });
        contextMap.push({ permissionType: SecurityPermissionType.Builtin_ProgramAdmin, context: 'ProgramAdmin' });
        contextMap.push({ permissionType: SecurityPermissionType.Builtin_Admin, context: 'Admin' });
        contextMap.push({ permissionType: SecurityPermissionType.Teacher_References, context: 'Teacher' });
        contextMap.push({ permissionType: SecurityPermissionType.Student_References, context: 'Student' });

        return contextMap;
    }



}